import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Acces a Brain — repond a la seule question qui compte : cette organisation
 * a-t-elle le plan ?
 *
 * La reponse vient de la base, via current_user_can_use_brain() (SECURITY
 * DEFINER, accordee a `authenticated`). Aucun drapeau cote front, aucune
 * colonne ajoutee : une seule source de verite, celle qui verrouille deja les
 * vues brain_signal_*.
 *
 * FERME PAR DEFAUT. Toute erreur — RPC absente, reseau, droits — rend false.
 * Un acces refuse a tort se voit et se corrige ; un acces ouvert a tort, non.
 *
 * Le resultat est mis en cache au niveau du module : la fonction est STABLE
 * pour une session, et la barre laterale se remonte a chaque navigation.
 */

let cachedAnswer = null;   // true | false, une fois resolu
let inFlight = null;       // la promesse partagee, pendant le vol

const askDatabase = async () => {
  if (cachedAnswer !== null) return cachedAnswer;
  if (!inFlight) {
    inFlight = (async () => {
      try {
        const { data, error } = await supabase?.rpc('current_user_can_use_brain');
        if (error) throw error;
        return data === true;
      } catch (err) {
        console.error('[useBrainAccess] RPC failed, access denied:', err?.message);
        return false;
      } finally {
        inFlight = null;
      }
    })();
  }
  cachedAnswer = await inFlight;
  return cachedAnswer;
};

const useBrainAccess = () => {
  const [canUseBrain, setCanUseBrain] = useState(cachedAnswer === true);
  const [loading, setLoading] = useState(cachedAnswer === null);

  useEffect(() => {
    if (cachedAnswer !== null) return;
    let cancelled = false;
    (async () => {
      const answer = await askDatabase();
      if (cancelled) return;
      setCanUseBrain(answer);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { canUseBrain, loading };
};

export default useBrainAccess;
